
export class TokenSettings {
  tokenExpiredOn?: string;
  tokenLifeTime?: string;
}
